import { SVGProps } from 'react';

const Oversize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 19a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 16H1v-6h7V5h9l6 6v5h-2q0 1.25-.875 2.125A2.9 2.9 0 0 1 18 19a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 15 16H9q0 1.25-.875 2.125A2.9 2.9 0 0 1 6 19m9-9h4l-3-3h-1zm-5 0h3V7h-3zm-4 7.25q.525 0 .888-.363.362-.362.362-.887t-.362-.887A1.2 1.2 0 0 0 6 14.75q-.525 0-.888.363A1.2 1.2 0 0 0 4.75 16q0 .525.362.887.363.363.888.363m12 0q.525 0 .887-.363.363-.362.363-.887t-.363-.887A1.2 1.2 0 0 0 18 14.75q-.525 0-.887.363a1.2 1.2 0 0 0-.363.887q0 .525.363.887.362.363.887.363"
    />
  </svg>
);
export default Oversize;
